// @ts-nocheck
import * as Types from '../../../gql/generated/graphql.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignInPagesSigninMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
  token: Types.Scalars['String']['input'];
}>;


export type SignInPagesSigninMutation = { __typename?: 'Mutation', signIn: Types.SignInResult };


export const SignInPagesSigninDocument = gql`
    mutation signInPagesSignin($id: String!, $password: String!, $token: String!) {
  signIn(id: $id, password: $password, token: $token)
}
    `;
export type SignInPagesSigninMutationFn = Apollo.MutationFunction<SignInPagesSigninMutation, SignInPagesSigninMutationVariables>;

/**
 * __useSignInPagesSigninMutation__
 *
 * To run a mutation, you first call `useSignInPagesSigninMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInPagesSigninMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInPagesSigninMutation, { data, loading, error }] = useSignInPagesSigninMutation({
 *   variables: {
 *      id: // value for 'id'
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSignInPagesSigninMutation(baseOptions?: Apollo.MutationHookOptions<SignInPagesSigninMutation, SignInPagesSigninMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInPagesSigninMutation, SignInPagesSigninMutationVariables>(SignInPagesSigninDocument, options);
      }
export type SignInPagesSigninMutationHookResult = ReturnType<typeof useSignInPagesSigninMutation>;
export type SignInPagesSigninMutationResult = Apollo.MutationResult<SignInPagesSigninMutation>;
export type SignInPagesSigninMutationOptions = Apollo.BaseMutationOptions<SignInPagesSigninMutation, SignInPagesSigninMutationVariables>;